import React, { Component } from 'react';

import './App.css';

class Partners extends Component {

  render() {
    return (
        <div className="partners-main">
          <div> The TGOJ </div>
        </div>
    );
  }
}

export default Partners;



/** WEBPACK FOOTER **
 ** ./src/Partners.js
 **/